import React from 'react';
import useDeviceOS from 'hooks/useDeviceOS';

import './index.css';

function Shortcuts() {
    const windowsShortcuts = (
        <table className='bcaShortcuts__table'>
            <tbody>
                <tr>
                    <th>Action</th>
                    <th>Shortcut</th>
                </tr>
                <tr>
                    <td>Zoom in</td>
                    <td>Control + Plus (+)</td>
                </tr>
                <tr>
                    <td>Zoom out</td>
                    <td>Control + Minus (-)</td>
                </tr>
                <tr>
                    <td>Zoom back to 100%</td>
                    <td>Control + 0</td>
                </tr>
                <tr>
                    <td>Back </td>
                    <td>Control + Alt + B</td>
                </tr>
                <tr>
                    <td>Next</td>
                    <td>Control + Alt + X</td>
                </tr>
                <tr>
                    <td>Open/Close Directions</td>
                    <td>Control + Alt + Shift + D</td>
                </tr>
                <tr>
                    <td>Hide/Show Timer</td>
                    <td>Control + Alt + T</td>
                </tr>
                <tr>
                    <td>Mark for Review</td>
                    <td>Control + Alt + V</td>
                </tr>
                <tr>
                    <td>Annotate</td>
                    <td>Control + Alt + A</td>
                </tr>
                <tr>
                    <td>Select/Deselect Option A</td>
                    <td>Control + Shift + 1</td>
                </tr>
                <tr>
                    <td>Select/Deselect Option B</td>
                    <td>Control + Shift + 2</td>
                </tr>
                <tr>
                    <td>Select/Deselect Option C</td>
                    <td>Control + Shift + 3</td>
                </tr>
                <tr>
                    <td>Select/Deselect Option D</td>
                    <td>Control + Shift + 4</td>
                </tr>
                <tr>
                    <td>Option Eliminator Mode</td>
                    <td>Control + Alt + M</td>
                </tr>
                <tr>
                    <td>Eliminate Option A</td>
                    <td>Control + Alt + 1</td>
                </tr>
                <tr>
                    <td>Eliminate Option B</td>
                    <td>Control + Alt + 2</td>
                </tr>
                <tr>
                    <td>Eliminate Option C</td>
                    <td>Control + Alt + 3</td>
                </tr>
                <tr>
                    <td>Eliminate Option D</td>
                    <td>Control + Alt + 4</td>
                </tr>
            </tbody>
        </table>
    );

    const macShortcuts = (
        <table className='bcaShortcuts__table'>
            <tbody>
                <tr>
                    <th>Action</th>
                    <th>Shortcut</th>
                </tr>
                <tr>
                    <td>Zoom in</td>
                    <td>Command + Plus (+)</td>
                </tr>
                <tr>
                    <td>Zoom out</td>
                    <td>Command + Minus (-)</td>
                </tr>
                <tr>
                    <td>Zoom Back to 100%</td>
                    <td>Command + 0</td>
                </tr>
                <tr>
                    <td>Back</td>
                    <td>Command + Ctrl + B</td>
                </tr>
                <tr>
                    <td>Next</td>
                    <td>Command + Ctrl + X</td>
                </tr>
                <tr>
                    <td>Open/Close Directions</td>
                    <td>Command + Ctrl + Shift + D</td>
                </tr>
                <tr>
                    <td>Hide/Show Timer</td>
                    <td>Command + Option + G</td>
                </tr>
                <tr>
                    <td>Mark for Review</td>
                    <td>Command + Shift + V</td>
                </tr>
                <tr>
                    <td>Annotate</td>
                    <td>Command + Option + A</td>
                </tr>
                <tr>
                    <td>Select/Deselect Option A</td>
                    <td>Command + Ctrl + 3</td>
                </tr>
                <tr>
                    <td>Select/Deselect Option B</td>
                    <td>Command + Ctrl + 4</td>
                </tr>
                <tr>
                    <td>Select/Deselect Option C</td>
                    <td>Command + Ctrl + 5</td>
                </tr>
                <tr>
                    <td>Select/Deselect Option D</td>
                    <td>Command + Ctrl + 6</td>
                </tr>
                <tr>
                    <td>Option Eliminator Mode</td>
                    <td>Command + Option + M</td>
                </tr>
                <tr>
                    <td>Eliminate Option A</td>
                    <td>Command + Ctrl + 7</td>
                </tr>
                <tr>
                    <td>Eliminate Option B</td>
                    <td>Command + Ctrl + 8</td>
                </tr>
                <tr>
                    <td>Eliminate Option C</td>
                    <td>Command + Ctrl + 9</td>
                </tr>
                <tr>
                    <td>Eliminate Option D</td>
                    <td>Command + Ctrl + 0</td>
                </tr>
            </tbody>
        </table>
    );

    return (
        <div className='bcaShortcuts'>
            <p className='bcaShortcuts__directions'>
                The following keyboard shortcuts have been configured to navigate to important functions within the digital exam.
            </p>
            {useDeviceOS() === 'mac_os'
                ? macShortcuts
                : windowsShortcuts
            }
        </div>
    );
}

export default Shortcuts;